import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import spaceService from '../../services/spaceService';
import toast from 'react-hot-toast';

export const fetchSpaces = createAsyncThunk(
  'space/fetchSpaces',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await spaceService.getSpaces(params);
      return data;
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch spaces');
    }
  }
);

export const fetchZones = createAsyncThunk(
  'space/fetchZones',
  async ({ warehouseId, params }, { rejectWithValue }) => {
    try {
      const { data } = await spaceService.getZones(warehouseId, params);
      return data;
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch zones');
    }
  }
);

export const createZone = createAsyncThunk(
  'space/createZone',
  async ({ warehouseId, zoneData }, { rejectWithValue }) => {
    try {
      const { data } = await spaceService.createZone(warehouseId, zoneData);
      toast.success('Zone created successfully');
      return data;
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to create zone');
    }
  }
);

export const fetchAllocations = createAsyncThunk(
  'space/fetchAllocations',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await spaceService.getAllocations(params);
      return data;
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch allocations');
    }
  }
);

export const fetchUtilisation = createAsyncThunk(
  'space/fetchUtilisation',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await spaceService.getUtilisationOverview(params);
      return data;
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch utilisation');
    }
  }
);

const initialState = {
  spaces: [],
  zones: [],
  allocations: [],
  utilisation: null,
  loading: false,
  zoneLoading: false,
  allocationLoading: false,
  error: null,
};

const spaceSlice = createSlice({
  name: 'space',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpaces.pending, (state) => { state.loading = true; })
      .addCase(fetchSpaces.fulfilled, (state, action) => {
        state.loading = false;
        state.spaces = (() => { const _d = action.payload; return Array.isArray(_d?.results) ? _d.results : Array.isArray(_d?.items) ? _d.items : Array.isArray(_d) ? _d : []; })();
      })
      .addCase(fetchSpaces.rejected, (state) => { state.loading = false; })
      .addCase(fetchZones.pending, (state) => { state.zoneLoading = true; })
      .addCase(fetchZones.fulfilled, (state, action) => {
        state.zoneLoading = false;
        state.zones = (() => { const _d = action.payload; return Array.isArray(_d?.results) ? _d.results : Array.isArray(_d?.items) ? _d.items : Array.isArray(_d) ? _d : []; })();
      })
      .addCase(fetchZones.rejected, (state) => { state.zoneLoading = false; })
      .addCase(createZone.fulfilled, (state, action) => {
        state.zones.push(action.payload);
      })
      .addCase(fetchAllocations.pending, (state) => { state.allocationLoading = true; })
      .addCase(fetchAllocations.fulfilled, (state, action) => {
        state.allocationLoading = false;
        state.allocations = (() => { const _d = action.payload; return Array.isArray(_d?.results) ? _d.results : Array.isArray(_d?.items) ? _d.items : Array.isArray(_d) ? _d : []; })();
      })
      .addCase(fetchAllocations.rejected, (state) => { state.allocationLoading = false; })
      .addCase(fetchUtilisation.fulfilled, (state, action) => {
        state.utilisation = action.payload;
      });
  },
});

export const { clearError } = spaceSlice.actions;
export default spaceSlice.reducer;
